import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './AdvancedSecurity.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import api from '../../axios-local-api';
import { FaExclamationTriangle, FaCheckCircle,FaTimesCircle } from 'react-icons/fa';
import Switch from '../../components/UI/Switch/Switch';
import Modal from '../../components/UI/Modal/Modal';

export class AdvancedSecurity extends Component {
  constructor(props){
    super(props)
    this.state = {
      confirmModal: false,
      checked: this.props.advancedSecurity && this.props.advancedSecurity.enabled ? this.props.advancedSecurity.enabled : false,
      error:false,
      success:true,
      advancedSecurityLoaded:false
     
    }
    this.handleToggleAdvancedSecurity = this.handleToggleAdvancedSecurity.bind(this);     
    this.confirmModalCancelHandler = this.confirmModalCancelHandler.bind(this);
    this.confirmModalConfirmHandler = this.confirmModalConfirmHandler.bind(this);
  }

  componentDidUpdate(prevProps){
       if(!this.state.advancedSecurityLoaded && this.props.advancedSecurityLoaded ){
        this.setState({          
          checked: this.props.advancedSecurity ? this.props.advancedSecurity.enabled : false,
          advancedSecurityLoaded:true
        });
    }
    if(this.state.advancedSecurityLoaded && !this.props.advancedSecurityLoaded ){
      this.setState({          
        advancedSecurityLoaded:false
      });
  }
  } 

  
  handleToggleAdvancedSecurity() {
    this.setState({ confirmModal: true })
  }

  confirmModalConfirmHandler() {
    this.setState((state) => ({ checked: !state.checked }));
    const payload = {
      enabled: this.state.checked ? false : true,
      method:'POST'
    }
    this.props.onAdvancedSecurityHandler(payload); 

    this.confirmModalCancelHandler()
  }

  confirmModalCancelHandler() {
    this.setState({ confirmModal: false })
  }

  

  render() {
    let switchBtn, securityLoglink, securityThreatsCnt = 0;
    if (this.props.securityThreats && this.props.oneDayTotal) {
      securityThreatsCnt = this.props.oneDayTotal;
    }

    let securityThreatsIcon = (
      <div>
        <FaCheckCircle
          className={classes.checkRightMob}
          color={'green'}
          style={{ marginRight: '5px', marginTop: '20px' }}
          fontSize={'20px'}
        />
      </div>
      
    );

    let securityThreatsMsg = (
      <span id='AdvanceSecurityText' className={classes.AdvanceSecurityThreatsNoInfo} > No threats detected.</span>
    );

    if (securityThreatsCnt > 0) {
      securityThreatsIcon = (
          <div>
          <FaExclamationTriangle
            color={'#dcc000'}
            fontSize={'30px'}
            style={{ marginRight: '5px', marginTop: '10px' }} />
          </div>
      );
      securityThreatsMsg = (<span id='AdvanceSecurityText' className={classes.AdvanceSecurityText} > {securityThreatsCnt} New Security events have been found on Customer Account. Please Review Security Shield Log for Details. </span>);
    }

    if (this.props.calledFrom && this.props.calledFrom === 'overview') {
      let advancedSecurityStatus = this.state.checked  ? 'ON' : 'OFF';
      let advancedSecurityStatusStyle = this.state.checked ? { backgroundColor: '#acf4719e', margin: '5px', padding: '6px' } :  { backgroundColor: 'lightgray', color:'gray', margin: '5px', padding: '6px' };
      let changeGroupObject = { 'showsecurityLogModal': true };
      securityLoglink = (<span className={classes.viewLogLink}><Link to={{ pathname: '/network', query: changeGroupObject, hash:'#advancedSecurityLogSection' }} href='/#advancedSecurityLogSection' >View log</Link></span>);
      if (this.props.advancedSecurity) {
        advancedSecurityStatus = this.props.advancedSecurity.enabled ? 'ON' : 'OFF';
        advancedSecurityStatusStyle = this.props.advancedSecurity.enabled  ? { backgroundColor: '#acf4719e', margin: '5px', padding: '6px' } :  { backgroundColor: 'lightgray', color:'gray', margin: '5px', padding: '6px' };
      }
      switchBtn = advancedSecurityStatus === 'OFF' ? 
        (<div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
        <span id= 'SecurityStatus'>Disabled </span>
      <FaTimesCircle
        color={'red'}
        style={{ marginLeft: '5px', marginRight: '5px' }}
        fontSize={'25px'}
          />
        </div>) : (
          <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
          <span id= 'SecurityStatus'>Enabled</span>
        <FaCheckCircle
          color={'green'}
          style={{ marginLeft: '5px', marginRight: '5px' }}
          fontSize={'25px'}
        />
        </div>
        );
          
    } else {
      switchBtn = (
        <Switch id='AdvancedSecurityToggle'
          aria-checked={this.state.checked}
          aria-label="Toggle Security Shield"
          onChange={this.handleToggleAdvancedSecurity}
          checked={this.state.checked}
        />
      );
      securityLoglink = (<div />)
    }

    let onOff;
    if(this.props.advancedSecurityLoading && !this.props.advancedSecurityLoaded){
      onOff = (
        <div className={classes.securityLogMessage}>
          <Spinner />
        </div>
      );
    }else if (this.props.advancedSecurity && this.props.advancedSecurity.enabled ) {
      onOff = (
        <div className={classes.securityLogMessage}>
          <div className={classes.TitleArea}>
            <div className={[classes.TitleLeft, classes.showDesktop].join(' , ')} style={{ justifyContent: 'flex-start' }}>
              <div style={{ display:'flex', flexDirection:'row' }}>
              {securityThreatsIcon}                                
              {securityThreatsMsg} 
              </div>
            </div>
            <div className={[classes.TitleRight, classes.showDesktop].join(' , ')} style={{ justifyContent: 'flex-end', paddingRight:'35px' }}>
              {securityLoglink}   
            </div> 
            
            <div className={classes.showMobile}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex' }}>
                  {securityThreatsIcon}
                  {securityThreatsMsg}
                </div>
              </div>
              {securityLoglink}
            </div>
          </div>
        </div>
      );
    } 
  
    let toggleConfirmation = (
      <Modal id = 'AdvSecurity' show={this.state.confirmModal} modalClosed={this.confirmModalCancelHandler}>
        {!this.state.checked && <p>Turn On Network Security? This will restore your added protection and notifications about outside threats to your network. Updates to Security Status can take up to 10 minutes to complete and are recorded in the change log.</p>}
        {this.state.checked && <p>Turn Off Network Security? This will remove your added protection and notifications about outside threats to your network. Updates to Security Status can take up to 10 minutes to complete and are recorded in the change log.</p>}
          <div className={classes.ButtonRow}>
          <button
            id='ModalCancelButton'
            className={classes.RegularButton}
            onClick={this.confirmModalCancelHandler}
          >
            {'Cancel'}
          </button>
  
          <button
            id='ModalOKButton'
            visibility='true'
            className={classes.RegularButton}
            onClick={this.confirmModalConfirmHandler}
          >
            {'Proceed'}
          </button>
        </div>
      </Modal>
    )

     return (
       <Box>
         <div className={classes.AdvancedSecurity}>
           <div className={classes.TitleArea}>
             <div className={classes.TitleLeft}>
               <h3 id='SISText' className={classes.ComponentTitle} >Security Shield</h3>
             </div>
             <div className={classes.TitleRight}>
               {switchBtn}
             </div>
           </div>
           {onOff}
         </div>
         {toggleConfirmation}
       </Box>
     )
  }
}
const mapStateToProps = (state=> {
    return {
      advancedSecurity: state.advancedSecurity.advancedSecurity,
      securityThreats: state.securityThreats.securityThreats,
      securityThreatsLoading: state.securityThreats.loading,
      securityThreatsLoaded: state.securityThreats.loaded,
      oneDayTotal: state.securityThreats.oneDayTotal,
      advancedSecurityLoading: state.advancedSecurity.loading,
      advancedSecurityLoaded: state.advancedSecurity.loaded,
      success: state.advancedSecurity.success,
      error: state.advancedSecurity.error
    };
  });
  
const mapDispatchToProps = (dispatch)=> {
  return {
    onAdvancedSecurityHandler: (payload) => dispatch(actions.advancedSecurityHandler(payload))
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(AdvancedSecurity, api));

